import OriginalsBanner from './OriginalsBanner';

export default OriginalsBanner;
